import { fallacies, categories as fallacyCategories } from "./fallacies";
import { quotes, categories as quoteCategories } from "./quotes";
import type { Collection, StoryItem } from "./types";

export const collections: Collection[] = [
  {
    slug: "fallacy",
    name: "Keliru",
    tagline: "Kenali kesalahan logika berpikir sehari-hari",
    bgColor: "#1e3a5f",
    items: fallacies,
    categories: fallacyCategories,
  },
  {
    slug: "quote",
    name: "Hikmah Islam",
    tagline: "Hikmah dari Al-Quran dan Hadits",
    bgColor: "#1a3c34",
    items: quotes,
    categories: quoteCategories,
  },
];

export function findItemBySlugAndId(slug: string, id: string): { collection: Collection; item: StoryItem } | null {
  const col = collections.find((c) => c.slug === slug);
  if (!col) return null;
  const item = col.items.find((i) => i.id === id);
  if (!item) return null;
  return { collection: col, item };
}

export function findItemById(id: string): { collection: Collection; item: StoryItem } | null {
  for (const col of collections) {
    const item = col.items.find((i) => i.id === id);
    if (item) return { collection: col, item };
  }
  return null;
}

export function allItems(): { collection: Collection; item: StoryItem }[] {
  return collections.flatMap((col) => col.items.map((item) => ({ collection: col, item })));
}
